var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconParentalControl = function SvgIconParentalControl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#b8c3d1",
    fillRule: "evenodd",
    d: "M12.767 7.116c.172-.415.422-.814.81-1.197.082-.082.037-.223-.08-.22-1.703.053-4.439 2.013-5.343 2.966h.006a5.4 5.4 0 1 0 4.607-1.55m.433 3.997a.9.9 0 1 0 1.8 0 .9.9 0 0 0-1.8 0m-4.2 0a.9.9 0 1 1 1.8 0 .9.9 0 0 1-1.8 0m5.86 2.306c.022-.186-.13-.337-.317-.337H9.458c-.187 0-.34.151-.318.336a2.88 2.88 0 0 0 5.72 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#b8c3d1",
    fillRule: "evenodd",
    d: "M1.813 5.863a1.275 1.275 0 0 1 .905-1.403l8.924-2.609c.234-.068.482-.068.716 0l8.925 2.609c.608.178.993.775.904 1.403l-1.124 7.924a9.56 9.56 0 0 1-5.366 7.295l-3.15 1.495a1.27 1.27 0 0 1-1.094 0l-3.15-1.495a9.56 9.56 0 0 1-5.366-7.295zM12 3.622l8.341 2.438-1.06 7.474a7.76 7.76 0 0 1-4.356 5.922L12 20.845l-2.925-1.39a7.76 7.76 0 0 1-4.355-5.92L3.66 6.06z",
    clipRule: "evenodd"
  })));
};
export default SvgIconParentalControl;